import { observer } from 'mobx-react-lite'
import type { RoutingEditorViewModel } from '@/features/legends/routing/RoutingEditorViewModel'
import { RoutingRequirements } from '@/features/legends/routing/components/RoutingRequirements'

export interface RoutingRequirementsContainerProps {
  vm: RoutingEditorViewModel
  testId?: string
}

export const RoutingRequirementsContainer = observer(
  function RoutingRequirementsContainer({
    vm,
    testId,
  }: RoutingRequirementsContainerProps) {
    return (
      <RoutingRequirements
        isEmpty={vm.requirements.isEmpty}
        isSelected={vm.isEditingRequirements}
        error={vm.validation.getError('requirements')}
        onPress={vm.editRequirements}
        testId={testId}
      />
    )
  },
)
